import * as React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {User} from 'nutshell-core/types';

import {Navbar} from './navbar';
import {NavbarSparse} from './navbar-sparse';

type OwnProps = {
    navbarMountId: string;
    user: User | null | undefined;
};
type Props = OwnProps & ContextRouter;

function NavbarPortalledComponent(props: Props) {
    const navbarMount = React.useMemo(() => {
        const mount = document.getElementById(props.navbarMountId);
        if (mount) {
            // Remove existing (plachoelder or previously-rendered nut.js) sidebar contents.
            while (mount.firstChild) {
                mount.removeChild(mount.firstChild);
            }
        }

        return mount;
    }, [props.navbarMountId]);

    if (!navbarMount) {
        return null;
    }

    const {dataset} = navbarMount;

    if (dataset.hasLicense === 'false') {
        return ReactDOM.createPortal(
            // @ts-expect-error
            <NavbarSparse userInitials={dataset.userInitials} user={props.user} />,
            navbarMount
        );
    }

    return ReactDOM.createPortal(
        // @ts-expect-error
        <Navbar userInitials={dataset.userInitials} user={props.user} />,
        navbarMount
    );
}

// @ts-expect-error
export const NavbarPortalled = withRouter<OwnProps>(NavbarPortalledComponent);
